import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Box, CircularProgress, Typography } from "@mui/material";

import { BsThreeDotsVertical } from "react-icons/bs";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../../redux/common/locationSlice";
import { formatDate, ShortenName2, whichStatus } from "../../../utils/const";
import SubmissionTrackerViewDrawer from "./SubmissionTrackerViewDrawer";
import { getOneSubmissionTracker } from "../../../redux/internal-tracking/InternalSubmissionSlice";
import { getProfile } from "../../../redux/profile/profileSlice";
import { Icon } from "@iconify/react/dist/iconify.js";

export default function PortalSubmissionTable({
  internalTrack,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
}) {
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(5);
  const [submisionRow, setSubmisionRow] = useState({});
  const [submisionIndex, setSubmisionIndex] = useState();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location);
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);
  const trackSubmissionStatus = useSelector(
    (state) => state.trackersubmission.status
  );
  const profile = useSelector((state) => state.profile.data);

  const [data, setData] = useState(
    JSON.parse(localStorage.getItem("internalSubmissionDetails"))
  );

  useEffect(() => {
    if (data?.names === "profile_view") {
      handleShow();
      setSubmisionRow(data?.row);
      localStorage.setItem(
        "internalSubmissionDetails",
        JSON.stringify({ row: data?.row, names: "" })
      );
    }
  }, [data]);

  useEffect(() => {
    if (data?.type === "view") {
      let id = data?.row?.requirement_id;
      dispatch(getOneSubmissionTracker(id));
      handleShow();
      setSubmisionRow(data?.row);
    }
  }, [data]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    dispatch(allWorkAuthorization());
    dispatch(getProfile());
  }, []);

  useEffect(() => {
    dispatch(allLocation());
  }, []);

  const getCandidate = (value) => {
    let result = value[0]?.full_name || "";
    return `${result} ${value?.length > 1 ? "+" : ""} ${
      value?.length > 1 ? value?.length - 1 : ""
    }`;
  };

  const getPreferLocationNames = (preferLocation) => {
    if (!preferLocation?.length) return "";

    const locationNames = preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      )
      .filter(Boolean); // Remove any undefined values

    if (locationNames.length === 0) return "";

    const firstLocation = locationNames[0];
    const remainingCount = locationNames.length - 1;

    return remainingCount > 0
      ? `${firstLocation} +${remainingCount}`
      : firstLocation;
  };

  const handleOnClickJobID = (column, row, index) => {
    if (column.id === "requirement_id") {
      localStorage.setItem(
        "internalSubmissionDetails",
        JSON.stringify({ row, index })
      );
      handleShow();
      setSubmisionRow(row);
      setSubmisionIndex(index);
    }
  };

  // const formatJobTypes = (jobTypes) => {
  //   return jobTypes.length > 1
  //     ? `${jobTypes[0]} +${jobTypes.length - 1}`
  //     : jobTypes[0];
  // };

  const formatJobTypes = (jobTypes) => {
    const formatText = (text) => {
      return text
        .split("_") // split words on underscore
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize each word
        .join(" "); // join back with space
    };

    if (!jobTypes || jobTypes.length === 0) return "";

    const first = formatText(jobTypes[0]);

    return jobTypes.length > 1 ? `${first} +${jobTypes.length - 1}` : first;
  };

  const columns = [
    {
      id: "requirement_id",
      label: "Job ID",
      minWidth: 70,
    },
    {
      id: "job_title",
      label: "Job Title",
      minWidth: 70,
    },

    {
      id: "location",
      label: "Location",
      minWidth: 70,
    },

    {
      id: "requirement_type",
      label: "Hiring Mode",
      minWidth: 50,
    },

    {
      id: "client_name",
      label: "Client",
      minWidth: 50,
    },

    {
      id: "rate",
      label: "Pay Rate",
      minWidth: 50,
    },
    {
      id: "mode_of_interview",
      label: "Interview",
      minWidth: 50,
    },

    {
      id: "created_at",
      label: "Date",
      minWidth: 50,
    },
    // {
    //   id: "submissions_for_requirement",
    //   label: "Candidates",
    //   minWidth: 50,
    // },

    // {
    //   id: "bdm_name",
    //   label:
    //     profile?.profile?.role === "BENCH_SALES_RECRUITER"
    //       ? "Recruiter"
    //       : "BDM",
    //   minWidth: 50,
    // },

    {
      id: "requirement_status",
      label: "Status",
      minWidth: 20,
    },
    // {
    //   id: "is_accepted_by_bdm",
    //   // label: "Action",
    //   // minWidth: 60,
    // },
  ];

  const formatStatusText = (text) => {
    return text
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <Box style={{ backgroundColor: "#fff", padding: "0" }}>
      <Paper
        sx={{
          overflow: "hidden",
        }}
      >
        <TableContainer sx={{ maxHeight: 640 }}>
          <Table
            stickyHeader
            aria-label="sticky table"
            style={{ borderSpacing: "0 2px" }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  style={{
                    minWidth: 50,
                    width: "20px",
                    backgroundColor: "#e5e7eb",
                    fontWeight: "600",
                    fontSize: "14px",
                    padding: "11px 14px 11px 1px",
                  }}
                >
                  <span>No.</span>
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      minWidth: column.minWidth,
                      backgroundColor: "#e5e7eb",
                      fontWeight: "600",
                      fontSize: "14px",
                      padding: "11px 14px 11px 1px",
                    }}
                  >
                    <span
                      style={
                        column.id === "slno"
                          ? {}
                          : {
                              borderLeft: "1.5px solid #ccc",
                              padding: "7px 1px 7px 11px",
                            }
                      }
                    >
                      {column.label}
                    </span>
                  </TableCell>
                ))}
                <TableCell
                  style={{
                    width: "20px",
                    backgroundColor: "#e5e7eb",
                    fontWeight: "600",
                    fontSize: "14px",
                    // padding: "11px 14px 11px 1px",
                  }}
                ></TableCell>
                <TableCell
                  style={{
                    width: "20px",
                    backgroundColor: "#e5e7eb",
                    fontWeight: "600",
                    fontSize: "14px",
                    padding: "11px 14px 11px 1px",
                  }}
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {trackSubmissionStatus === "loading" ? (
                <TableRow>
                  <TableCell colSpan={columns.length}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      py={4}
                    >
                      <CircularProgress color="info" />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : internalTrack?.length > 0 ? (
                internalTrack
                  // ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                      >
                        <TableCell
                          align="center"
                          style={{
                            fontSize: "14px",
                            backgroundColor: "#f8f9fa",
                            padding: "11px 15px",
                            fontFamily: "Calibri",
                            color: "inherit",
                            cursor: "pointer",
                          }}
                        >
                          {index + 1}
                        </TableCell>
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              style={{
                                fontSize: "13px",
                                // fontWeight: 600,
                                // backgroundColor: '#DEEBF7',
                                backgroundColor: "#f8f9fa",
                                padding: "11px 15px",
                                fontFamily: "Calibri",
                                cursor:
                                  column.id === "requirement_id"
                                    ? "pointer"
                                    : "",
                                textDecoration:
                                  column.id === "requirement_id"
                                    ? "underline"
                                    : "",
                                color:
                                  column.id === "population"
                                    ? "#154e83"
                                    : column.id === "density"
                                    ? "#00B050"
                                    : column.id === "date"
                                    ? "#154e83"
                                    : "inherit",
                              }}
                              key={column.id}
                              align={column.align}
                              onClick={() =>
                                handleOnClickJobID(column, row, index)
                              }
                            >
                              {column.format && typeof value === "number"
                                ? column.format(value)
                                : column.id === "created_at"
                                ? formatDate(value)
                                : // : column.id === "submissions_for_requirement"
                                // ? getCandidate(value)
                                // : column.id === "action"
                                // ? row["submissions_for_requirement"]?.length >
                                //     0 &&
                                //   whichStatus(
                                //     row["submissions_for_requirement"][index]
                                //       ?.progress[0]?.submission_status
                                //   )
                                column.id === "requirement_status"
                                ? value === "Active"
                                  ? `Open ${
                                      row?.submissions_for_requirement?.length >
                                      0
                                        ? row?.submissions_for_requirement
                                            ?.length
                                        : ""
                                    }`
                                  : value
                                : column.id === "requirement_type"
                                ? formatJobTypes(value)
                                : column.id === "job_title"
                                ? ShortenName2(value)
                                : column.id === "location"
                                ? getPreferLocationNames(value)
                                : // ) : column.id === "is_accepted_by_bdm" ? (
                                //   value === "PENDING" ? (
                                //     <Icon
                                //       icon="bi:hourglass-top"
                                //       height={20}
                                //       width={20}
                                //     />
                                //   ) : value === "ACCEPTED" ? (
                                //     <Icon
                                //       icon="meteor-icons:check-double"
                                //       height={20}
                                //       width={20}
                                //       color="#797979"
                                //     />
                                //   ) : (
                                //     <Icon
                                //       icon="iconoir:multiple-pages-delete"
                                //       height={20}
                                //       width={20}
                                //       color="#797979"
                                //     />
                                //   )
                                column.id === "rate"
                                ? `$${row?.rate}${
                                    row?.requirement_type?.includes("full_Time")
                                      ? "K Yearly"
                                      : " Hourly"
                                  }`
                                : value}
                            </TableCell>
                          );
                        })}

                        <TableCell
                          align="center"
                          style={{
                            fontSize: "14px",
                            backgroundColor: "#f8f9fa",
                            padding: "11px 15px",
                            fontFamily: "Calibri",
                            color: "inherit",
                            cursor: "pointer",
                          }}
                        >
                          {row?.requirement_created_by !== "SALES_MANAGER" ? (
                            row?.is_accepted_by_bdm === "PENDING" ? (
                              <Icon
                                icon="bi:hourglass-top"
                                height={18}
                                width={18}
                              />
                            ) : row?.is_accepted_by_bdm === "ACCEPTED" ? (
                              <Icon
                                icon="meteor-icons:check-double"
                                height={18}
                                width={18}
                                color="#797979"
                              />
                            ) : (
                              <Icon
                                icon="iconoir:multiple-pages-delete"
                                height={18}
                                width={18}
                                color="#797979"
                              />
                            )
                          ) : row?.bdm_requirement_accepted_by_recruiter ===
                            false ? (
                            <Icon
                              icon="bi:hourglass-top"
                              height={20}
                              width={20}
                            />
                          ) : (
                            <Icon
                              icon="meteor-icons:check-double"
                              height={20}
                              width={20}
                              color="#797979"
                            />
                          )}
                        </TableCell>

                        <TableCell
                          style={{
                            fontSize: "13px",
                            backgroundColor: "#f8f9fa",
                            padding: "11px 15px",
                            fontFamily: "Calibri",
                            color: "inherit",
                            cursor: "pointer",
                          }}
                        >
                          <Box
                            variant="contained"
                            size="large"
                            onClick={() => {
                              // navigate("/internal-view", {
                              //   state: { row: row, index: index },
                              // });
                              localStorage.setItem(
                                "internalSubmissionDetails",
                                JSON.stringify({ row, index })
                              );
                              handleShow();
                              setSubmisionRow(row);
                              setSubmisionIndex(index);
                            }}
                          >
                            <BsThreeDotsVertical />
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })
              ) : (
                <TableRow>
                  <TableCell colSpan={columns.length + 2} align="center">
                    <Typography
                      variant="h6"
                      style={{
                        color: "#666",
                        fontFamily: "Calibri",
                        padding: "20px",
                      }}
                    >
                      No Submission Found
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          component="div"
          count={internalTrack?.length ?? 0}
          rowsPerPage={rowsPerPage}
          // page={page}
          page={Math.min(
            page,
            Math.max(
              0,
              Math.ceil((internalTrack?.length ?? 0) / rowsPerPage) - 1
            )
          )}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      <SubmissionTrackerViewDrawer
        handleShow={handleShow}
        handleClose={handleCloseShow}
        show={show}
        row={submisionRow}
        index={submisionIndex}
      />
    </Box>
  );
}
